function redirectPlaToPdp () {

	const sfpRegEx = /\/sfp\//i;
	const productsPath = '/p/';

	if (window.top.location.href.match(sfpRegEx)) {

		// sfp
		window.top.location = window.top.location.href.replace(sfpRegEx, productsPath);

	}

}

export default redirectPlaToPdp;
